import reducer from './reducers';

export { default as duckOperations } from './operations';
export { default as duckTypes } from './types';

export default reducer;
